var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 2.5C9.64654 2.5 9.29951 2.59365 8.99389 2.77148C8.68899 2.94888 8.43608 3.20377 8.26065 3.51046L8.2594 3.51264L1.93613 14.4712C1.7598 14.7776 1.66682 15.1252 1.6665 15.479C1.66619 15.8329 1.75856 16.1806 1.93435 16.4873C2.11014 16.7941 2.36319 17.0491 2.66814 17.2268C2.97309 17.4045 3.31923 17.4987 3.67189 17.5L3.67493 17.5H16.3247L16.3278 17.5C16.6804 17.4987 17.0266 17.4045 17.3315 17.2268C17.6365 17.0491 17.8895 16.7941 18.0653 16.4873C18.2411 16.1806 18.3335 15.8329 18.3332 15.479C18.3329 15.1252 18.2399 14.7776 18.0635 14.4712L11.7403 3.51264L11.7391 3.51057C11.5637 3.20383 11.3107 2.9489 11.0058 2.77148C10.7002 2.59365 10.3531 2.5 9.99984 2.5ZM10.8623 8.55779C10.8623 8.07986 10.4762 7.69242 9.99985 7.69242C9.52351 7.69242 9.13736 8.07986 9.13736 8.55779V10.8655C9.13736 11.3434 9.52351 11.7308 9.99985 11.7308C10.4762 11.7308 10.8623 11.3434 10.8623 10.8655V8.55779ZM11.1498 13.75C11.1498 14.3873 10.635 14.9039 9.99985 14.9039C9.36473 14.9039 8.84987 14.3873 8.84987 13.75C8.84987 13.1128 9.36473 12.5962 9.99985 12.5962C10.635 12.5962 11.1498 13.1128 11.1498 13.75Z",
    fill: "#F78317"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9ccbd08665ac4c903d7855ce4a6e1b45.svg";
export { ForwardRef as ReactComponent };